import { PartyPopper, Banknote, DollarSign, Landmark } from "lucide-react";
import { MetricCard, SectionHeading, ngn, usd, EMPTY_BUCKET } from "./ui";

export default function WatchPartyOverview({ data }) {
  const d = data || {};
  const n = { ...EMPTY_BUCKET, ...(d.ngn || {}) };
  const u = { ...EMPTY_BUCKET, ...(d.usd || {}) };
  return (
    <section data-testid="watch-party-overview">
      <SectionHeading eyebrow="Group viewing" title="Watch Party overview" description="All parties created, gross revenue (including extensions) and the platform's 30% share." />
      <div className="grid grid-cols-2 xl:grid-cols-6 gap-4">
        <MetricCard label="Parties created" value={(d.total_created || 0).toLocaleString()} hint={`${d.paid || 0} paid`} icon={PartyPopper} testId="wp-total-created" />
        <MetricCard label="Revenue · ₦" value={ngn(n.gross)} hint={`${n.count} paid parties`} icon={Banknote} testId="wp-revenue-ngn" />
        <MetricCard label="Revenue · $" value={usd(u.gross)} hint={`${u.count} paid parties`} icon={DollarSign} testId="wp-revenue-usd" />
        <MetricCard accent label="Platform 30% · ₦" value={ngn(n.platform)} icon={Landmark} tone="text-gold" testId="wp-platform-ngn" />
        <MetricCard accent label="Platform 30% · $" value={usd(u.platform)} icon={Landmark} tone="text-gold" testId="wp-platform-usd" />
        <MetricCard label="Creator share" value={`${ngn(n.gross - n.platform)}`} hint={`+ ${usd(u.gross - u.platform)}`} testId="wp-creator-share" />
      </div>
    </section>
  );
}
